<template>
    <div :class="{ 'm-unit-info': true, 'm-unit-info--frame': frame, 'm-unit-info--black-frame-on-hover': blackFrameOnHover, 'm-unit-info--hidden':!isActive }" ref="unitPopup">
        <slot></slot>
    </div>
</template>

<script>
/* eslint-disable indent */

export default {
    name: 'MapLabel',
    inject:['mapViewer'],
    props:{
        position: { type: String, default:'' },
        positionX: { type: String, default:'middle' }, // left, middle, right
        positionY: { type: String, default:'bottom' }, // top, middle, bottom
        selectedUnit:[String, Number],
        target: { type: String, default: 'unit'}, //unit, floor
        frame:{ type: Boolean, default: false},
        blackFrameOnHover: { type: Boolean, default: false},
        maxDistance: { type: [Number, Boolean], default: false },
        minDistance: { type: [Number, Boolean], default: false },
        fixedY: { type: [Number, Boolean], default: false },
        fixedX: { type: [Number, Boolean], default: false },
        offsetX: { type: [Number], default: 0 },
        offsetY: { type: [Number], default: 0 },
        calcDistance: { type: Boolean, default: false},
        calcOverlap: { type: Boolean, default: false},

        targetCoordinates: {type: Object, default: null},
        targetFloor: {type: String, default: null},
        minScale: {type: Number, default: 1},
        maxScale: {type: Number, default: 1},
        progress: {type: Number, default: 0}
    },
    data(){
        return {
            isActive: true,
            cameraUpdateTimeout: null,
        }
    },
    methods:{
        handleCameraUpdate() {
            if(this.minDistance){
                this.isActive = this.minDistance < this.mapViewer.viewApi.camera_controller.reference_zoom;
            }
            if(this.maxDistance){
                this.isActive = this.maxDistance > this.mapViewer.viewApi.camera_controller.reference_zoom;
            }

            if(!this.isActive || !this.$refs.unitPopup || !this.mapViewer.viewApi) return;

            let pos = null;
            if(this.targetCoordinates && this.targetFloor){
                pos = this.getFloorCoordinatesScreenPos();
            }

            if ( !pos && this.selectedUnit != null ) {

                switch (this.target) {
                    case 'vertex':
                        pos = this.mapViewer.streetsEditor[`get_${this.target}_screen_pos`](this.selectedUnitInt);
                        break;
                    case 'guide_step':
                        pos = this.positionY === 'top' ?
                            this.mapViewer.viewApi.get_step_bottom_screen_pos(this.selectedUnitInt)
                            : this.mapViewer.viewApi.get_step_top_screen_pos(this.selectedUnitInt);
                        break;
                    case 'guide_vertex':
                        pos = this.mapViewer.viewApi.get_street_vertex_screen_pos(this.selectedUnitInt);
                        break;
                    case 'progress':
                        pos = this.mapViewer.viewApi.get_guide_progress_screen_pos(this.progress);
                        break;
                    default:
                        pos = this.mapViewer.viewApi[`get_${this.target}_screen_pos`](this.selectedUnit);
                }
            }

            if (pos) {
                this.$refs.unitPopup.style.transform = `translate3d(${this.fixedX || pos.x}px,${this.fixedY || pos.y}px,0px)`;
            }
            else {
                console.error(`MapHtmlLabel: can't get position for unit ${this.selectedUnit}. Removing label`)
                this.mapViewer.viewApi && this.mapViewer.viewApi.deregister_event('on_camera_update', this.handleCameraUpdate);
                this.isActive = false
            }
        },
        updatePopupOffset(){
            if(!this.$refs.unitPopup || !this.isActive) return
            // TODO: add positions, default is middle-bottom
            if(this.frame){
                this.$refs.unitPopup.style.left = this.frame ? `-${40+this.offsetX}px` : `-${this.$refs.unitPopup.offsetWidth/2 + this.offsetX}px`
                this.$refs.unitPopup.style.top  = `-${18+this.$refs.unitPopup.offsetHeight+this.offsetY}px`

            }
            else
            {
                switch(this.positionX)
                {
                    case 'left':
                        if(this.offsetX)
                            this.$refs.unitPopup.style.left = `${this.offsetX}px`
                        break;
                    case 'middle':
                        this.$refs.unitPopup.style.left = `-${this.$refs.unitPopup.offsetWidth/2 + this.offsetX}px`
                        break;
                    case 'right':
                        this.$refs.unitPopup.style.left = `-${this.$refs.unitPopup.offsetWidth + this.offsetX}px`
                        break;
                }
                switch(this.positionY)
                {
                    case 'top':
                        if(this.offsetY)
                            this.$refs.unitPopup.style.top = `${this.offsetY}px`
                        break;
                    case 'middle':
                        this.$refs.unitPopup.style.top  = `-${this.$refs.unitPopup.offsetHeight/2+this.offsetY}px`
                        break;
                    case 'bottom':
                        this.$refs.unitPopup.style.top  = `-${this.$refs.unitPopup.offsetHeight+this.offsetY}px`
                        break;
                }
            }

        },
        getFloorCoordinatesScreenPos(){
            return this.targetCoordinates && this.targetFloor ?
                this.mapViewer.viewApi.get_floor_screen_pos_with_offset(this.targetFloor, this.targetCoordinates) : null
                //this.mapViewer.viewApi.get_point_on_floor_screen_pos(this.targetCoordinates,this.targetFloor) : null
        },
        handleCameraUpdateIn500ms(){
            clearTimeout(this.cameraUpdateTimeout);
            this.cameraUpdateTimeout = setTimeout(() => this.handleCameraUpdate(), 10);
        }

    },
    computed:{
        selectedUnitInt(){ return parseInt(this.selectedUnit,10) },

        /* popupWidth(){return this.$refs.unitPopup ? this.$refs.unitPopup.offsetWidth : 0},
        popupHeight(){return this.$refs.unitPopup ? this.$refs.unitPopup.offsetHeight : 0}, */
    },
    watch:{
        '$route': 'handleCameraUpdateIn500ms',
        'mapViewer.$data.containerWidth': 'handleCameraUpdate',
        'mapViewer.$data.containerHeight': 'handleCameraUpdate',
    },
    updated(){
        if(this.isActive){
            this.updatePopupOffset()
            this.handleCameraUpdate()

        }
    },
    mounted(){
        this.mapViewer.viewApi.register_event('on_camera_update', this.handleCameraUpdate);

        this.updatePopupOffset();
        this.handleCameraUpdate();

        setTimeout(this.updatePopupOffset,100)
        setTimeout(this.handleCameraUpdate,100)
        setTimeout(this.updatePopupOffset, 3000)
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.handleCameraUpdate);

    }
}
</script>

<style lang="scss">

.m-unit-info {
  position: absolute;
  top: 0px;
  left: 0px;
  will-change: transform;

  &--frame{
    padding: 10px;
    //.unit_info
    background: #fff;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    flex-flow: row wrap;
    font-family: "Pantone Regular", sans-serif;
    font-size: 12px;
  }

  &--hidden{
    display: none !important;
  }

  p{ margin: 0px; }
}

.m-unit-info--black-frame-on-hover:hover{
  background-color: #000000;
  cursor: pointer;

  &::after {
    border-top-color: #000000;
  }
}

.m-unit-info--frame::after {
  position: absolute;
  bottom: -18px;
  left: 20px;
  order: 3;
  border-left: 20px solid transparent;
  border-top: 20px solid #ffffff;
  content: "";
}
</style>
